import axiosInstance, { axiosInstanceCached } from '@/utils/axios';
import Configuration from '@/utils/configuration';
import { handleApiError, deleteDataCache } from '@/utils/helpers';

const API_HOST = Configuration.value('VUE_APP_API_HOST');

export const list = async () => {
  try {
    const response = await axiosInstanceCached.get(`/me/desktop-licenses`, {
      id: 'list_licenses',
      cache: {
        ttl: 1000 * 60 * 5,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const listMobile = async () => {
  try {
    const response = await axiosInstanceCached.get(`/me/mobile-licenses`, {
      id: 'list_mobile_licenses',
      cache: {
        ttl: 1000 * 60 * 5,
      },
    });
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const showMobile = async (licenseID) => {
  try {
    const response = await axiosInstance.get(`/mobile-licenses/${licenseID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const show = async (licenseID) => {
  try {
    //! Hotfix for license token issue
    const response = await axiosInstance.get(`/mobile-licenses/${licenseID}`);
    // const response = await axiosInstance.get(`/desktop-licenses/${licenseID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const destroy = async (desktopLicenseID) => {
  try {
    const response = await axiosInstance.delete(
      `${API_HOST}/desktop-licenses/${desktopLicenseID}/authentication`
    );
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const destroyMobile = async (mobileLicenseID) => {
  try {
    const response = await axiosInstance.delete(
      `${API_HOST}/mobile-licenses/${mobileLicenseID}/authentication`
    );
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// * Potentially remove this endpoint if not using
export const showSim = async (licenseID) => {
  try {
    const response = await axiosInstance.get(`/desktop-licenses/${licenseID}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

//* Submit product key for redemption
// @ "productKey": "",
// @ "email" "",
// @ "userID":"",
// @ "clientOS": "windows" or "ios"
// @ licenseID param can be 'create' to create a new core license
export const submitKey = async ({
  payload,
  licenseID,
  originalTransactionID,
  isPermission = false,
}) => {
  let response = {};

  const url = `/productkeys/consume${licenseID ? `?licenseID=${licenseID}` : ''}${
    originalTransactionID
      ? `${licenseID ? '&' : '?'}originalTransactionID=${originalTransactionID}`
      : ''
  }`;

  try {
    response = await axiosInstance.post(url, payload);
    await deleteDataCache(axiosInstanceCached, true, 'list_licenses');
    await deleteDataCache(axiosInstanceCached, true, 'list_mobile_licenses');
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getProductKey = async (key) => {
  let response = {};

  try {
    response = await axiosInstance.get(`/productkeys/${key}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
